import React from 'react';
import { Route} from 'react-router-dom';
import { ProfilePage } from '/imports/ui/ProfilePage';
import { OrgPage } from '/imports/ui/OrgPage';
import { OrgsPage } from '/imports/ui/OrgsPage';
import { UsersPage } from '/imports/ui/UsersPage';
import { UserPage } from '/imports/ui/UserPage';
import { AccountPage } from '/imports/ui/AccountPage';
import { AccountsPage } from '/imports/ui/AccountsPage';
import { LogsPage } from '/imports/ui/LogsPage';
import { AccountProfilePage } from '/imports/ui/AccountProfilePage';
import { ReNavigatePage } from '/imports/ui/ReNavigatePage';
import { Logout } from '/imports/ui/Logout';
import { SupportTicketsPage } from '/imports/ui/SupportTicketsPage';
import { SupportTicketPage } from '/imports/ui/SupportTicketPage';
import { MyOrgPage } from '/imports/ui/MyOrgPage';

/**
 * Builds the shared set of routes under a given path prefix.
 * @param prefix - Path segment prepended to each route.
 * @returns Array of Route elements.
 */
export const CommonRoutes = (prefix: string) => [
  <Route key="account-profile" path={`/${prefix}/profile/:accountId`} element={<AccountProfilePage />} />,
  <Route key="profile" path={`/${prefix}/profile`} element={<ProfilePage />} />,
  <Route key="myOrg" path={`/${prefix}/my-org`} element={<MyOrgPage />} />,
  <Route key="user" path={`/${prefix}/users/:_id`} element={<UserPage />} />,
  <Route key="users" path={`/${prefix}/users`} element={<UsersPage />} />,
  <Route key="org" path={`/${prefix}/orgs/:_id`} element={<OrgPage />} />,
  <Route key="orgs" path={`/${prefix}/orgs`} element={<OrgsPage />} />,
  <Route key="account" path={`/${prefix}/accounts/:_id`} element={<AccountPage />} />,
  <Route key="accounts" path={`/${prefix}/accounts`} element={<AccountsPage />} />,
  <Route key="supportTicket" path={`/${prefix}/support/:_id`} element={<SupportTicketPage />} />,
  <Route key="supportTickets" path={`/${prefix}/support`} element={<SupportTicketsPage />} />,
  <Route key="logout" path={`/${prefix}/logout`} element={<Logout />} />,
  <Route key="logs" path={`/${prefix}/logs`} element={<LogsPage />} />,
  <Route key="renavigate" path={`/${prefix}/rn`} element={<ReNavigatePage />} />
];
